import { FormattedMessage } from 'react-intl';

export const legalMessages = {
  'legal.termsAndConditions.heading': (
    <FormattedMessage
      id="legal.termsAndConditions.heading"
      defaultMessage="Terms & Conditions and Privacy Policy"
    />
  ),
  'legal.termsAndConditions.subHeading': (
    <FormattedMessage
      id="legal.termsAndConditions.subHeading"
      defaultMessage="Please read and accept the following to continue"
    />
  ),
  'legal.termsAndConditions.backButton': (
    <FormattedMessage
      id="legal.termsAndConditions.backButton"
      defaultMessage="Back"
    />
  ),
  'legal.termsAndConditions.acceptButton': (
    <FormattedMessage
      id="legal.termsAndConditions.acceptButton"
      defaultMessage="Accept"
    />
  ),
  'legal.termsAndConditions.acceptingButtonText': (
    <FormattedMessage
      id="legal.termsAndConditions.acceptingButtonText"
      defaultMessage="Accepting..."
    />
  ),
};
